//请自行添加语言资源
const shipper = {
  shipperCode: '货主编号',
  shipperName: '货主名称',
  shipperShortName: '货主简称',
  shipTypeName: '默认运输方式',
  contactMan: '联系人',
  contactTel: '联系电话',
  contactMail: '联系邮箱',
  contactMobile: '联系手机',
  contactAddr: '地址',
  companyName: '所属机构',
  useCompanyName: '使用机构',
  activeOffDesc: '是否有效',
  createTime: '创建时间',
  creator: '创建者',
  updateTime: '修改时间',
  updater: '修改者',
  entityName: '企业主体',
  msg: {
    shipperCode: '请输入货主编号',
    shipperName: '请输入货主名称',
    shipTypeName: '请选择默认运输方式',
    companyName: '请选择所属机构',
    companyCode: '请选择所属机构',
    entityName: '请选择企业主体',
    activeOffDesc: '请选择是否有效',
  }
};
export default shipper



// WEBPACK FOOTER //
// ./src/page/mdm/shipper/lang/shipper.zh.js